import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, timeout, catchError } from 'rxjs/operators';
import { Auth, authState } from '@angular/fire/auth';

export const emailVerifiedGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(Auth);

  // First check synchronously if we have a current user with verified email
  if (auth.currentUser) {
    if (auth.currentUser.emailVerified) {
      return of(true);
    } else {
      router.navigate(['/email-verification']);
      return of(false);
    }
  }

  // If no synchronous user, check via authState observable
  return authState(auth).pipe(
    take(1),
    timeout(5000),
    map(user => {
      if (!user) {
        // User not authenticated, redirect to auth
        router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
        return false;
      }

      if (!user.emailVerified) {
        // User authenticated but email not verified, redirect to verification
        router.navigate(['/email-verification']);
        return false;
      }

      // User authenticated and email verified
      return true;
    }),
    catchError((error) => {
      console.error('Email verified guard: Error checking auth state:', error);
      // For AbortError or similar, try to proceed if we have a current user
      if (auth.currentUser && auth.currentUser.emailVerified) {
        return of(true);
      } else {
        router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
        return of(false);
      }
    })
  );
};
